(() => {
  const CUSTOM_BUTTON_SELECTOR =
    '[data-square-wishlist-trigger]';

  const SQUARE_BUTTON_SELECTOR =
    '.Vtl-WishlistButton__AddToWishlist';

  const SQUARE_TEXT_SELECTOR =
    '.Vtl-WishlistButton__AddToWishlistText';

  let observer = null;
  let updateTimer = null;

  function getCustomButton() {
    return document.querySelector(
      CUSTOM_BUTTON_SELECTOR
    );
  }

  function getSquareButton() {
    return document.querySelector(
      SQUARE_BUTTON_SELECTOR
    );
  }

  function getSquareButtonText() {
    const textElement = document.querySelector(
      SQUARE_TEXT_SELECTOR
    );

    return textElement
      ? textElement.textContent.trim().toLowerCase()
      : '';
  }

  function isProductInWishlist() {
    const buttonText = getSquareButtonText();

    return (
      buttonText.includes('added to wishlist') ||
      buttonText.includes('remove from wishlist')
    );
  }

  function updateCustomButton() {
    const customButton = getCustomButton();
    const squareButton = getSquareButton();

    if (!customButton) {
      return;
    }

    /*
     * Keep the custom button disabled until the Square
     * wishlist button has finished loading.
     */
    const squareReady = Boolean(squareButton);

    customButton.disabled = !squareReady;
    customButton.classList.toggle(
      'is-unavailable',
      !squareReady
    );

    if (!squareReady) {
      customButton.setAttribute(
        'aria-label',
        'Wishlist is loading'
      );

      customButton.setAttribute(
        'title',
        'Wishlist is loading'
      );

      return;
    }

    const saved = isProductInWishlist();

    customButton.classList.toggle(
      'is-active',
      saved
    );

    customButton.setAttribute(
      'aria-pressed',
      String(saved)
    );

    if (saved) {
      customButton.setAttribute(
        'aria-label',
        'Remove product from wishlist'
      );

      customButton.setAttribute(
        'title',
        'Remove from wishlist'
      );
    } else {
      customButton.setAttribute(
        'aria-label',
        'Add product to wishlist'
      );

      customButton.setAttribute(
        'title',
        'Add to wishlist'
      );
    }
  }

  function scheduleUpdate(delay = 50) {
    window.clearTimeout(updateTimer);

    updateTimer = window.setTimeout(
      updateCustomButton,
      delay
    );
  }

  function handleCustomButtonClick(event) {
    const customButton = event.target.closest(
      CUSTOM_BUTTON_SELECTOR
    );

    if (!customButton) {
      return;
    }

    event.preventDefault();

    const squareButton = getSquareButton();

    if (!squareButton) {
      return;
    }

    customButton.disabled = true;
    customButton.classList.add('is-loading');

    /*
     * Trigger Square's real wishlist control.
     * Square remains responsible for saving and removing
     * the product from the customer's wishlist.
     */
    squareButton.click();

    /*
     * Square updates its HTML asynchronously, so check
     * the state again after the request completes.
     */
    window.setTimeout(() => {
      customButton.disabled = false;
      customButton.classList.remove('is-loading');
      updateCustomButton();
    }, 800);
  }

  function observeSquareWishlist() {
    if (observer) {
      observer.disconnect();
    }

    observer = new MutationObserver(() => {
      scheduleUpdate();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: [
        'class',
        'style',
        'aria-pressed'
      ]
    });
  }

  function initialiseSquareWishlistBridge() {
    document.removeEventListener(
      'click',
      handleCustomButtonClick
    );

    document.addEventListener(
      'click',
      handleCustomButtonClick
    );

    observeSquareWishlist();
    updateCustomButton();

    /*
     * The Square app can take a moment to inject its
     * button after the product page has loaded.
     */
    window.setTimeout(updateCustomButton, 300);
    window.setTimeout(updateCustomButton, 1000);
    window.setTimeout(updateCustomButton, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialiseSquareWishlistBridge
    );
  } else {
    initialiseSquareWishlistBridge();
  }

  document.addEventListener(
    'shopify:section:load',
    initialiseSquareWishlistBridge
  );
})();